/**
 * EditToggleButton Component
 *
 * Lock/unlock toggle button for inline editing (tickets/tasks).
 */

import React from "react";
import { Button } from "@/components/ui/button";
import { Lock, Unlock } from "lucide-react";
import { cn } from "@/lib/utils";

interface EditToggleButtonProps {
  isUnlocked: boolean;
  isDisabled: boolean;
  isLoading: boolean;
  label: string;
  onClick: () => void;
  isDropdown?: boolean;
}

const EditToggleButtonBase: React.FC<EditToggleButtonProps> = ({
  isUnlocked,
  isDisabled,
  isLoading,
  label,
  onClick,
  isDropdown = false,
}) => {
  return (
    <Button
      variant={isUnlocked ? "default" : "outline"}
      size={isDropdown ? "sm" : "default"}
      disabled={isDisabled || isLoading}
      onClick={onClick}
      className={cn(
        "gap-2 min-h-[44px] touch-manipulation active:scale-[0.98]",
        isUnlocked && "bg-emerald-600 hover:bg-emerald-700 text-white border-emerald-600"
      )}
    >
      {isUnlocked ? (
        <Unlock className="h-4 w-4 shrink-0" aria-hidden />
      ) : (
        <Lock className="h-4 w-4 shrink-0" aria-hidden />
      )}
      <span>{label}</span>
    </Button>
  );
};

export const EditToggleButton = React.memo(EditToggleButtonBase);
